<form
  class="category-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  @if (isMerchandisingRoot) {
    <p class="form-notice" role="note">
      Categoría protegida: su nombre y ubicación no se pueden modificar. Solo puedes cambiar la foto.
    </p>
  }

  <div class="form-group">
    <label class="form-label is-required" for="category-name">Nombre</label>
    <input
      id="category-name"
      type="text"
      class="form-input"
      formControlName="name"
      placeholder="Ej: Juguetería."
      autocomplete="off"
    />
    @if (nameInvalid()) {
      <span class="form-error">El nombre es requerido (máx. 80 caracteres).</span>
    }
  </div>

  @if (isEditingSubcategory) {
    <div class="form-group">
      <label class="form-label" for="category-parent">Categoría Padre</label>
      <select
        id="category-parent"
        class="form-input"
        formControlName="parentId"
        [attr.disabled]="hasParentOptions() && !isMerchandisingSubcategory ? null : true"
      >
        <option value="">
          @if (hasParentOptions()) {
            Ninguna (Esta es la Categoría Principal)
          } @else {
            Crea una categoría padre primero
          }
        </option>
        @if (isMerchandisingSubcategory) {
          <option [value]="form.controls.parentId.value">Merchandising</option>
        }
        @for (parent of parentOptions(); track parent.id) {
          <option [value]="parent.id">{{ parent.name }}</option>
        }
      </select>

      @if (isMerchandisingSubcategory) {
        <span class="form-hint">Las subcategorías de Merchandising no se pueden mover a otra categoría.</span>
      }
    </div>
  }

  <div class="form-group">
    <label class="form-label">Fotos</label>
    <app-image-uploader
      [maxImages]="1"
      [simple]="true"
      [optimizeForCatalog]="true"
      [initialUrls]="initialImageUrls"
      (imagesChange)="onImagesChange($event)"
    />
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Cancelar
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      {{ isEditing ? 'Guardar cambios' : 'Crear categoría' }}
    </button>
  </div>
</form>
